module.exports = __webpack_public_path__ + "static/img/1.de34c21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/line/1.jpg
// module id = Z2Yj
// module chunks = 1